import { createSlice } from "@reduxjs/toolkit";

export interface ArchivedState {
    value: boolean
}

const initialState: ArchivedState = {
    value: false,
}

const archivedStateReducer = createSlice({
    name: 'ArchivedWorkOrder',
    initialState,
    reducers: {
        // define your reducers here
        setArchivedState: (state) => {
            state.value = true;
        },
        resetArchivedState: (state) => {
            state.value=false;
        },
    },
});
export const { setArchivedState, resetArchivedState } = archivedStateReducer.actions
export default archivedStateReducer.reducer